// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1___4beca5f9c8a6e33dbe2","cls2":"CreateSocialItemModal-cls2___8f4df7187ec0612ed71 CreateSocialItemModal-cls1___4beca5f9c8a6e33dbe2"};